const formatAddress = (address) => {
  if (!address || typeof address !== 'object') {
    return '';
  }

  const { streetAddress, streetNumber, postalCode, locality, region, country } =
    address;

  const addressParts = [];

  // Street address with number
  if (streetAddress || streetNumber) {
    const streetPart = [streetAddress, streetNumber]
      .filter((part) => part && part.toString().trim())
      .join(' ');
    if (streetPart) {
      addressParts.push(streetPart);
    }
  }

  // Postal code and locality
  if (postalCode || locality) {
    const cityPart = [postalCode, locality]
      .filter((part) => part && part.toString().trim())
      .join(' ');
    if (cityPart) {
      addressParts.push(cityPart);
    }
  }

  // Region
  if (region && region.toString().trim()) {
    addressParts.push(region.toString().trim());
  }

  // Country
  if (country && country.toString().trim()) {
    addressParts.push(country.toString().trim());
  }

  return addressParts.join(', ');
};

export default formatAddress;
